import React__default from 'react';

var ArticleRelationLink = function ArticleRelationLink(props) {
  var link = props.link;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "text-action-primary decoration-primary"
  }, link.title, link.subtext && /*#__PURE__*/React__default.createElement("p", {
    className: "font-sans text-p-16 leading-6 text-action-base-inverse decoration-base-inverse"
  }, link.subtext));
};

export { ArticleRelationLink };
//# sourceMappingURL=article-relation-link.esm.js.map
